import {
	AbstractControl,
	AbstractControlOptions,
	AsyncValidatorFn,
	FormControl,
	FormGroup,
	ValidatorFn
} from "@angular/forms";
import {FormControlValidators} from "./validators/validator";
import {Subject} from "rxjs";

export class BaseFormGroup extends FormGroup {
	public $beforeSubmit: Subject<Function> = new Subject<Function>();
	public sendFormError: Error = null;
	
	setData(data: any): void {
		const me = this;
		
		for (const key of Object.getOwnPropertyNames(data)) {
			const control = me.get(key);
			
			if (control) {
				control.setValue(data[key]);
			}
		}
	}
	
	getData(): any {
		return this.value;
	}
}

export class SupportModalForm extends BaseFormGroup {
	constructor(controls: {
		[key: string]: AbstractControl;
	}, validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null, asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null) {
		super(controls, validatorOrOpts, asyncValidator);
		
		this.addControl(
			'comment',
			new FormControl('', [
				FormControlValidators.required(),
				FormControlValidators.minLength(10),
			])
		);
	}
}
